import { createEnumeratorAttrMap, IEnumeratorModel } from "./IEnumeratorModel";

export type IPravniFormaModel = IEnumeratorModel;
export const PravniFormaAttrMap = createEnumeratorAttrMap('Pravni_forma');
